import React, { useEffect, useMemo, useState } from 'react';
import { Vector3Tuple } from 'three';

import { useEventCallback } from '@spazious/react-hooks';

import { Arrow, ArrowUpdatePayload } from '../Arrow/index.js';
import { Polygon } from '../Polygon/index.js';

export type CameraPathUpdateEvent = {
  points: [Vector3Tuple, Vector3Tuple][];
  first: boolean;
  last: boolean;
};

export interface CameraPathProps {
  points: [Vector3Tuple, Vector3Tuple][];
  color?: string;
  lineWidth?: number;
  disabled?: boolean;
  onUpdate?: (event: CameraPathUpdateEvent) => void;
  onSelect?: () => void;
}

export const CameraPath: React.FC<CameraPathProps> = ({
  points,
  color = 'blue',
  lineWidth = 2,
  disabled = false,
  onUpdate,
  onSelect,
}) => {
  const [currentPoints, setCurrentPoints] = useState(points);

  useEffect(() => {
    setCurrentPoints([...points]);
  }, [points]);

  const handleArrowUpdate = useEventCallback((index: number, payload: ArrowUpdatePayload) => {
    const newPoints = [...currentPoints];

    if (payload.type === 'start') {
      newPoints[index][0] = [...payload.start];
    } else if (payload.type === 'end') {
      newPoints[index][1] = [...payload.end];
    } else if (payload.type === 'move') {
      newPoints[index][0] = [...payload.start];
      newPoints[index][1] = [...payload.end];
    }

    setCurrentPoints(newPoints);
    onUpdate?.({ points: newPoints, first: payload.first, last: payload.last });
  });

  const arrows = useMemo(() => {
    return currentPoints.map(([start, end], i) => {
      // _va.set(...start);
      // _vb.set(...end);
      // const dir = _vb.sub(_va).normalize();
      // const target = _va.clone().add(dir.multiplyScalar(Math.max(1, _va.distanceTo(_vb) * 0.2)));
      return (
        <Arrow
          key={`${i}`}
          color={color}
          disabled={disabled}
          end={end}
          // label={'' + (i + 1)}
          lineWidth={lineWidth}
          start={start}
          onClick={onSelect}
          onUpdate={(payload) => handleArrowUpdate(i, payload)}
        />
      );
    });
  }, [color, currentPoints, disabled, handleArrowUpdate, lineWidth, onSelect]);

  if (!currentPoints || currentPoints.length < 2) return null;

  return (
    <>
      <Polygon
        color="orange"
        fill={false}
        points={currentPoints.map((p) => p[0])}
        onClick={onSelect}
      />
      {arrows}
    </>
  );
};
